// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconPlus = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 18,
    width: 18,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-plus">
      <svg
        className="c-icon-plus fill-current"
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.8754 8.38127H9.64727V1.12502C9.64727 0.787524 9.36602 0.478149 9.00039 0.478149C8.66289 0.478149 8.35352 0.759399 8.35352 1.12502V8.38127H1.12539C0.787891 8.38127 0.478516 8.66252 0.478516 9.02815C0.478516 9.36565 0.759766 9.67503 1.12539 9.67503H8.38164V16.875C8.38164 17.2125 8.66289 17.5219 9.02852 17.5219C9.36602 17.5219 9.67539 17.2407 9.67539 16.875V9.6469H16.8754C17.2129 9.6469 17.5223 9.36565 17.5223 9.00002C17.5223 8.66253 17.2129 8.38127 16.8754 8.38127Z" fill={fill || 'white'} />
      </svg>
    </Icon>
  );
};

export default IconPlus;
